import React from 'react'
import styled from 'styled-components'
import {connect} from 'react-redux'
import {injectIntl} from 'react-intl'
import {Add} from '@mui/icons-material'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import Dialog from 'components/Dialog'
import DataExport from 'components/DataExport'
import DraggableList from 'components/DraggableList'
import {
    deleteExportTemplate,
    exportData,
    setExportDataTemplatesOrder
} from 'modules/exportdata/actions'
import {fetchLinkedOptions} from 'modules/linkedfield/actions'
import {getDataExportTemplates} from 'utils/utils'

const List = styled(MenuItem)`
	font-size: 14px;
	line-height: normal;

	&:hover {
		color: #ffc300;
        background-color: rgba(22, 22, 27, 1);
	}
`

class DataExportContent extends React.Component {
    constructor(props) {
        super(props)

        this.template = null
        this.templates = null

        this.state = {
            openDialog: false,
            openMenu: false
        }
    }

    componentDidMount() {
        this.templates = getDataExportTemplates(this.props.entity)

        if (this.templates && this.templates.length) {
            this.handleOpenMenu()
        } else {
            this.handleOpenDialog()
        }
    }

    handleOpenMenu = () => {
        this.setState({
            openMenu: true
        })
    }

    handleCloseMenu = () => {
        this.setState({
            openMenu: false
        }, () => this.props.handleClose())
    }

    handleOpenDialog = () => {
        this.setState({
            openDialog: true,
            openMenu: false
        })
    }

    handleCloseDialog = () => {
        this.template = null
        this.setState({
            openDialog: false
        }, () => this.props.handleClose())
    }

    selectTemplate = (e) => {
        const id = Number(e.currentTarget.getAttribute('data-list-item-id'))
        this.template = this.templates.find(item => item.id === id)
        this.handleOpenDialog()
    }

    exportData = (template) => {
        const documents = this.props.selected.length ?
            this.props.documents.filter(item => this.props.selected.includes(item.id)) : []

        this.props.exportData(template, documents)
        this.handleCloseDialog()
    }

    onReorder = (order) => {
        this.props.setExportDataTemplatesOrder(this.props.entity, order)
    }

    render() {
        const {intl, entity, entities, permissions} = this.props

        return (
            <React.Fragment>
                <Menu
                    anchorEl={this.props.anchorEl}
                    open={this.state.openMenu}
                    onClose={this.handleCloseMenu}
                    PaperProps={{
						sx: {
							background: '#333340',
							color: 'rgba(255, 255, 255, .7)',
							borderRadius: 0
						}
					}}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                >
                    <List onClick={this.handleOpenDialog} disableRipple>
                        <Add
							sx={{
								marginRight: '10px',
								fontSize: '20px'
							}}
						/>
                        {intl.formatMessage({id: "sidebar.create_data_export_template"})}
                    </List>
                    {this.templates &&
                        <DraggableList
                            data={this.templates}
                            onClick={this.selectTemplate}
                            onReorder={this.onReorder}
                        />
                    }
                </Menu>
                {this.state.openDialog &&
                    <Dialog
                        fullWidth={true}
                        maxWidth='md'
                        open={this.state.openDialog}
                        onClose={this.handleCloseDialog}
                    >
                        <DataExport
                            entity={entity}
                            entities={entities}
                            name={this.props.name}
                            handleClose={this.handleCloseDialog}
                            template={this.template}
                            sending={!!this.props.selected.length}
                            exportData={this.exportData}
                            deleteTemplate={this.props.deleteExportTemplate}
                            permissions={permissions}
                            linkedOptions={this.props.linkedOptions}
                            fetchLinkedOptions={this.props.fetchLinkedOptions}
                        />
                    </Dialog>
                }
            </React.Fragment>
        )
    }
}

const mapStateToProps = ({collection, entities, login, linkedfield}) => ({
    selected: collection.selected,
    documents: collection.documents,
    entities: entities.entities,
    permissions: login.permissions,
    linkedOptions: linkedfield.linkedOptions
})

export default connect(mapStateToProps, {
    deleteExportTemplate,
    exportData,
    fetchLinkedOptions,
    setExportDataTemplatesOrder
})(injectIntl(DataExportContent))
